export default __webpack_public_path__ + "static/code-a64d9972b620261db75966496f59ccd1.jpeg";